import { Component, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/shared/services/data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-message-block',
  templateUrl: './message-block.component.html',
  styleUrls: ['./message-block.component.scss']
})
export class MessageBlockComponent {
  @Input() data: any;
  constructor(private http: HttpClient, private dataService: DataService, private router: Router) {}
  messages: any = null;

  ngOnInit(){
    this.getMessages();
  }

  getMessages(){
    let url = environment.apiUrl+"/portal/messageBlockList/getMessages";
    let request = {
        cultureCode: this.dataService.getCultureCode(),
    }
    this.dataService.getDataByToken(url,request).subscribe({
        next: (data) => 
        {
          this.messages = data.messages;
        },
        error: (e) => console.error(e)
    });
  }
}
